import { FiRefreshCw } from 'react-icons/fi'
import is from 'typescript-styled-is'
import styled from '../../../theme'

const SpinningIcon = styled(FiRefreshCw)<ISpinningIconProps>`
  @-webkit-keyframes icon-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  @keyframes icon-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  animation: icon-spin 2s infinite linear;
  ${is('animationTime')`
    animation: icon-spin ${({ animationTime }: ISpinningIconProps) =>
      animationTime}s infinite linear;
  `};
`

export default SpinningIcon

export interface ISpinningIconProps {
  animationTime?: number
  size?: string | number
  animating?: boolean
}
